import type { Resource } from '../../';
export const forms_address_line1: Resource = {"default":"Address Line 1"};
